// extracted by css-extract-rspack-plugin
module.exports =  {"section_wrapper":"Gepo3","header":"x6ZhT","changecity":"fYowA","bottomspacing":"ZHpK5","topspacing":"GgMaR","rhs_border":"vkzD3","inFocus":"vSOST","rightNews":"aKePo"};